// 智慧党建
import { getZHDJList, getZHDJDetailById } from '@/api'

const state = {
	parkType: 0,
	pageList: {
		totalRow: 0, //	总条数
		pageNumber: 0,
		firstPage: false,
		lastPage: false,
		totalPage: 0, //	总页数
		pageSize: 0,
		list: [
			/*      {
              "img": "http://XXX/oss/getOssFileJumping?filecode=2021-06-11-ace3f0e2-5f3e-43fb-9549-e26f8f1f1d15",
              "parktype": "1", //	类型	1 党建活动  2 学习园地 3 学习强国
              "ctime": "2021-06-12 00:00:00", //	发布时间
              "id": "d0c0121847814fdab373578f4c68cb6a", //	主键 （修改需用到）
              "title": "12312", //	标题
              "content": "<p style=\"color: rgb(102, 102, 102);\"> </p>", //	列表简介
              "content_intro": "123123123" //	列表简介
            }*/
		],
	},
	detail: {
		ctime: '',
		title: '',
		content: '',
	},
}
const mutations = {
	SET_PAGE_LIST(state, payload) {
		state.pageList = payload
	},
	SET_PARK_TYPE(state, payload) {
		state.parkType = payload
	},
	SET_DETAIL(state, payload) {
		state.detail = payload
	},
}
const actions = {
	fetchPageList({ commit }, payload = {}) {
		const parkType = payload.parkType || 1
		const page = payload.page || 1
		const limit = payload.limit || 10
		commit('SET_PARK_TYPE', parkType)
		getZHDJList(parkType, page, limit).then((pageList = {}) => {
			commit('SET_PAGE_LIST', pageList)
		})
	},
	fetchDetailById({ commit }, id = '') {
		getZHDJDetailById(id).then((detail = {}) => {
			commit('SET_DETAIL', detail)
		})
	},
	handleCurrentChange({ state, dispatch }, currentPage) {
		const params = {
			parkType: state.parkType,
			page: currentPage,
		}
		dispatch('fetchPageList', params)
	},
}
export default {
	namespaced: true,
	state,
	mutations,
	actions,
}
